/**
 * scripts-core-theme.js
 * -----------------------------------------------------------------------
 * Global theme bootstrap. Loaded on every page (deferred) before any
 * component script. Keep this file small: it should only perform
 * foundational, cross-cutting setup, never feature-specific logic.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';

  var root = document.documentElement;

  // Swap the no-js class for js as soon as this script executes so CSS can
  // progressively enhance JS-dependent UI (see html[data-js] hook usage).
  root.classList.remove('no-js');
  root.classList.add('js');

  // Lightweight, shared pub/sub bus for cross-component communication
  // (e.g. a future cart drawer reacting to an "add to cart" event) without
  // coupling components together directly.
  var subscribers = Object.create(null);

  function subscribe(eventName, callback) {
    if (!subscribers[eventName]) subscribers[eventName] = [];
    subscribers[eventName].push(callback);
    return function unsubscribe() {
      subscribers[eventName] = subscribers[eventName].filter(function (cb) {
        return cb !== callback;
      });
    };
  }

  function publish(eventName, detail) {
    (subscribers[eventName] || []).forEach(function (callback) {
      callback(detail);
    });
  }

  window.AniMarket = window.AniMarket || {};
  window.AniMarket.events = {
    subscribe: subscribe,
    publish: publish,
  };
})();
